import { Component, input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'htx-text-field',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './text-field.component.html',
  styleUrl: './text-field.component.scss'
})
export class TextFieldComponent {
  private uniqueId = Math.random().toString(36).substring(2, 11);

  /** FormControl instance for managing the input field's value and validation state */
  ctrl = input.required<AbstractControl>();

  /** Label text displayed above the input field */
  label = input<string>();

  /** Whether to display a required indicator (*) next to the label */
  required = input<boolean>(false);

  /** Placeholder text for the input field (overrides label as placeholder) */
  placeholder = input<string>();

  /** Optional helper text shown below the field */
  hint = input<string>();

  /** Whether the input should be masked as a password field */
  isPassword = input<boolean>(false);

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }

  getUniqueId(): string {
    return this.uniqueId;
  }
}
